import _remove from 'lodash/remove';
import addEmployeeTemplate from './../../settings/add-employee/add-employee.html';
import editEmployeeTemplate from './../../settings/edit-employee/edit-employee.html';
import template from './school-common-room-employees.html';

class SchoolCommonRoomEmployeesComponent {
  /** @ngInject */
  constructor(
    $log, $q, $mdDialog, $mdToast, $state,
    SchoolCommonRoomService,
    EmployeeService
  ) {
    this.$log = $log;
    this.$q = $q;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.$state = $state;
    this.SchoolCommonRoomService = SchoolCommonRoomService;
    this.EmployeeService = EmployeeService;

    this.columnKeys = ['fullNameWithAccount', 'roleName'];
  }

  $onInit() {
    if (this.user.isAdmin) {
      this.columnKeys.push('id');
    }
  }

  $onChanges(changes) {
    if (changes.user) {
      this.user = {...this.user};
    }

    if (changes.schoolCommonRoom) {
      this.schoolCommonRoom = {...this.schoolCommonRoom};
    }

    if (changes.employees) {
      this.employees = Object.assign([], this.employees);
    }

    if (changes.unassignedEmployees) {
      this.unassignedEmployees = Object.assign([], this.unassignedEmployees);
    }

    if (changes.roles) {
      this.roles = Object.assign([], this.roles);
    }
  }

  add(ev) {
    this.EmployeeService.getUnassignedEmployees(this.schoolCommonRoom.id, true).then(result => {
      this.unassignedEmployees = result;
      this.$mdDialog.show({
        bindToController: true,
        controllerAs: 'ctrl',
        controller: 'AddEmployeeController',
        template: addEmployeeTemplate,
        clickOutsideToClose: true,
        locals: {
          unassignedEmployees: this.unassignedEmployees,
          roles: this.roles,
          schoolCommonRoom: this.schoolCommonRoom
        },
        targetEvent: ev
      })
        .then(employee => {
          employee.fullNameWithAccount = employee.fullName;
          this.employees.unshift(employee);
        }, () => {});
    });
  }

  edit(id, ev) {
    const employee = {...this.employees.filter(item => item.id === id)[0]};
    this.$mdDialog.show({
      bindToController: true,
      controllerAs: 'ctrl',
      controller: 'EditEmployeeController',
      template: editEmployeeTemplate,
      clickOutsideToClose: true,
      locals: {
        employee,
        roles: this.roles,
        schoolCommonRoom: this.schoolCommonRoom
      },
      targetEvent: ev
    })
      .then(() => {
        this.EmployeeService.getSchoolCommonRoomEmployees(this.schoolCommonRoom.id, true)
          .then(result => {
            this.employees = Object.assign([], result);
          });
      }, () => {})
      .finally(() => {
        this.EmployeeService.getUnassignedEmployees().then(result => {
          this.unassignedEmployees = result;
        });
      });
  }

  remove(employeeId) {
    const employee = {...this.employees.filter(item => item.id === employeeId)[0]};
    this.EmployeeService.deleteEmployee(employee, this.schoolCommonRoom.id)
      .then(employee => {
        _remove(this.employees, item => item.id === employee.id);
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Usunięto nauczyciela ze świetlicy')
            .position('bottom right')
            .hideDelay(3000)
        );
      })
      .catch(error => {
        this.$mdDialog.show(
          this.$mdDialog.extendError({
            locals: {error}
          })
        );
      });
  }

  back(ev) {
    ev.stopPropagation();
    this.$state.go('configuration.schoolCommonRooms', {}, {reload: true});
  }
}

export const SchoolCommonRoomEmployees = {
  bindings: {
    user: '<',
    schoolCommonRoom: '<',
    employees: '<',
    unassignedEmployees: '<',
    roles: '<'
  },
  template,
  controller: SchoolCommonRoomEmployeesComponent
};
